// index.js
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import App from './App';

// Sentry 초기화 (프로덕션만)
if (process.env.NODE_ENV === 'production' && process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: 'production',
    release: process.env.REACT_APP_SENTRY_RELEASE || undefined,
    tracesSampleRate: 0,
    sendDefaultPii: false,
  });
}

// 환경변수 검증
if (!process.env.REACT_APP_API_BASE_URL) {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      padding: '2rem',
      textAlign: 'center',
      backgroundColor: '#f8f9fa'
    }}>
      <div style={{
        backgroundColor: '#fff',
        borderRadius: '12px',
        padding: '3rem',
        boxShadow: '0 2px 12px rgba(0,0,0,0.1)',
        maxWidth: '480px',
        width: '100%'
      }}>
        <h2 style={{ color: '#dc3545', marginBottom: '1rem' }}>
          환경 설정 오류
        </h2>
        <p style={{ color: '#6c757d' }}>
          <code>REACT_APP_API_BASE_URL</code> 환경변수가 설정되지 않았습니다.
          <br />
          <code>.env</code> 파일을 확인해 주세요.
        </p>
      </div>
    </div>
  );
} else {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(<App />);
}
